import { useCallback } from 'react';

import { AxiosResponse } from 'axios';
import { useInfiniteQuery, UseInfiniteQueryResult } from 'react-query';
import { UrlParams } from 'types';
import { PaginatedKiloClassTypeList } from 'types/generated/models/PaginatedKiloClassTypeList';
import { client } from 'utils/api-client';
import { encodeUrlParams, urlParamsFromUrl } from 'utils/functions';

interface QueryKeyType {
  pageParam?: UrlParams;
}

interface IUseClassTypes {
  ordering?: string;
  limit?: string;
}

function useClassTypes({
  ordering,
  limit = '20',
}: IUseClassTypes): UseInfiniteQueryResult<AxiosResponse<PaginatedKiloClassTypeList>> {
  const fetchClassTypes = useCallback(
    ({
      pageParam = { limit, offset: '0' },
    }: QueryKeyType): Promise<AxiosResponse<PaginatedKiloClassTypeList>> => {
      const params = pageParam;
      if (ordering) {
        params.ordering = ordering.replace(/[A-Z]/g, letter => `_${letter.toLowerCase()}`).concat(',pk');
      }
      return client.get(`kilo-class-types/?${encodeUrlParams(pageParam)}`);
    },
    [limit, ordering],
  );

  return useInfiniteQuery(['classType', ordering], fetchClassTypes, {
    getNextPageParam: page => {
      return page.data.next ? urlParamsFromUrl(page.data.next) : undefined;
    },
  });
}

export default useClassTypes;
